export default "__VITE_ASSET__C$HZgIbF__"